__turbopack_context__.v({
  "activeLanguage": "arFiJq_activeLanguage",
  "language": "arFiJq_language",
  "languageButton": "arFiJq_languageButton",
  "languageDivider": "arFiJq_languageDivider",
  "skiplink": "arFiJq_skiplink",
});
